module.exports = __webpack_public_path__ + "3e7f32ff363b18ea887e85e4e77c4fb0.pdf";